import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import {useForm} from "react-hook-form";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import ReactMultiSelectAsync from "../../Components/Inputs/ReactMultiSelectAsync";

export default function () {
  const { reset, handleSubmit, control, watch, getValues } = useForm();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const searchProduct = (val) => {
    let selectedProducts = getValues('products');
    return axios.get('best-selling-products/filter', {
      params: {keyword: val, product_ids: selectedProducts, shop_id: getValues('shop_id')}
    }).then(res => {
      setData({...data, products: res.data?.products});
      return res.data?.products;
    });
  }

  useEffect(() => {
    axios.get('best-selling-products').then(res => {
      if(res.data.status === 'success'){
        setData(res.data)
        reset({'products': res.data.product_list});
      }
    });
  }, []);

  const edit = data => {
    axios.put('best-selling-products', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('List has been updated successfully!', {
            icon: "success",
          });
          navigate("/best-selling-products");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit best selling products">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>

        <ReactSelectInput
          label="Shop (Filter)"
          name="shop_id"
          className="col-md-12 col-sm-6 pt-3"
          options={data?.shops}
          control={control}
          errorMessage={errors?.shop_id}
        />

        <ReactMultiSelectAsync
          label="Products"
          name="products"
          placeholder="Choose Products"
          className="col-md-12 col-sm-6 pt-3"
          inputClassName="col-md-6"
          values={data?.products} //options
          errorMessage={errors?.products}
          control={control}
          search={searchProduct}
          defaultOptions={true}
          loadTrigger={watch(['products', 'shop_id'])}
        />

        <SubmitButton
          title="Save"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}